import axios from "../Axios";
import { withCdnCookie } from "../../app/cdnCookie";
import { fmt } from "../../pages/videos/scenes/sceneModel";

const userFolder = () => JSON.parse(localStorage.getItem("user") || "{}").user_folder;

// projectId -> promise of the video's {project_name, duration, cdn, video, thumb}, for the page's session
const projects = new Map();

/**
 * What the moments of a video need to show it: its name and length (as MomentPreview reads a video), its CDN folder
 * (frame sprites), its low resolution video and thumbnail; resolved once the CDN cookie is set
 */
export default function projectInfo(projectId) {
  if (!projects.has(projectId)) {
    const project = axios.get("/video_project/" + projectId);
    const videos = axios.get("/video_project/" + projectId + "/videos", { params: { video_type: "LOW_RESOLUTION" } });
    const promise = withCdnCookie(Promise.all([project, videos])).then(([p, v]) => {
      const cdn = userFolder() + "/" + p.data.project_folder;
      const video = v.data[0] || {};
      return {
        project_name: p.data.project_name,
        duration: p.data.duration ? fmt(p.data.duration) : "", // "47:59"
        cdn,
        video: video.video_path || cdn + "/video_lowres.mp4",
        thumb: video.thumbnail_path || cdn + "/video_lowres_thumbnail.jpg",
      };
    });
    promise.catch(() => projects.delete(projectId));
    projects.set(projectId, promise);
  }
  return projects.get(projectId);
}
